import { mapActions } from 'vuex'

export default {
    methods: {
        ...mapActions('yodizproject/tasks', {
            updateTask: 'updateListObject',
            setTaskListProperty: 'setSingleListProperty'
        }),

        dragEnter (event) {
            event.preventDefault();

            if ( event.target.classList.contains("droppable") ) {
                event.target.style.backgroundColor = "#cbcbcb";
            }
        },

        dragLeave (event) {
            event.preventDefault();

            if ( event.target.classList.contains("droppable") ) {
                event.target.style.backgroundColor = "#cbcbcb";
            }

            event.target.style.backgroundColor = "";
        },

        dragFinish (storyId, status, event) {
            event.preventDefault();

            var taskId = event.dataTransfer.getData("text");

            event.target.style.backgroundColor = "";

            var now = moment().format('X');

            let payload = {
                'status': status,
                'last_drag': now
            }

            //Update the local state with the drop location
            this.setTaskListProperty({ id: taskId, property: 'status', value: status })
            this.setTaskListProperty({ id: taskId, property: 'last_drag', value: now })
            
            //Story Id isn't required on the issue board
            if (storyId) {
                this.setTaskListProperty({ id: taskId, property: 'story_id', value: storyId })
                payload.story_id = storyId 
            }

            //Update the server
            this.updateTask({id: taskId, payload: payload}).then((response) => {
                //this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
                this.setTaskListProperty({ id: taskId, property: 'last_drag', value: response.data.last_drag })
                
            }).catch((response) => {
                notify.error("Failed to move task, please reload your browser.")
            })
        },
    }
}